import {trackEvent} from "../utils/plausible";

export function courseLesson(){
    Alpine.data('lesson', () => ({
        user_is_logged_in: false,
        user_is_subscribed: false,
        show_card: false,

        show_assignment_card: false,

        show_modal: false,

        init() {
            this.user_is_logged_in = (site_objects.user_is_logged_in === 'true');
            this.user_is_subscribed = (site_objects.user_is_logged_in === 'true' && site_objects.user_is_subscribed === "true");
            this.show_card = ((this.user_is_logged_in && !this.user_is_subscribed) || (!this.user_is_logged_in));
            this.show_assignment_card = (this.user_is_logged_in && this.user_is_subscribed);
        },

        trigger_copy_paste: {
            ["@click"](e) {
              let doc = document,
                  text = doc.getElementById("assignments"),
                  range,
                  selection;

                if (doc.body.createTextRange)
                {
                    range = doc.body.createTextRange();
                    range.moveToElementText(text);
                    range.select();
                }

                else if (window.getSelection)
                {
                    selection = window.getSelection();
                    range = doc.createRange();
                    range.selectNodeContents(text);
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
                document.execCommand('copy');
                window.getSelection().removeAllRanges();
            },
        },

        trigger_open_assignment: {
            ["@click"]() {
                if(!this.user_is_logged_in){
                    this.show_assignment_card = !this.show_assignment_card;
                }

                if(this.user_is_logged_in){
                    this.show_assignment_card = !this.show_assignment_card
                }

                if(this.user_is_logged_in && this.user_is_subscribed){
                    this.show_assignment_card = true
                    this.show_card = true
                }
            }
        },

        trigger_modal: {
          ["@click"]() {
              this.show_modal = true;

              if(this.user_is_logged_in){
                  this.$dispatch('show-form', true)
              }
          }
        },

        assignment_btn_text : {
            ["x-text"]() {
                return (this.show_assignment_card) ? AlpineI18n.t('assignment_open') : AlpineI18n.t('assignment_closed')
            }
        },

    }))
}